
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","id":"Braces--Streamline-Bootstrap","height":"16","width":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.114 8.063V7.9c1.005 -0.102 1.497 -0.615 1.497 -1.6V4.503c0 -1.094 0.39 -1.538 1.354 -1.538h0.273V2h-0.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094 -0.376 1.456 -1.49 1.456v1.299c1.114 0 1.49 0.362 1.49 1.456v1.524c0 1.593 0.759 2.352 2.372 2.352h0.376v-0.964h-0.273c-0.964 0 -1.354 -0.444 -1.354 -1.538V9.663c0 -0.984 -0.492 -1.497 -1.497 -1.6M13.886 7.9v0.163c-1.005 0.103 -1.497 0.616 -1.497 1.6v1.798c0 1.094 -0.39 1.538 -1.354 1.538h-0.273v0.964h0.376c1.613 0 2.372 -0.759 2.372 -2.352v-1.524c0 -1.094 0.376 -1.456 1.49 -1.456V7.332c-1.114 0 -1.49 -0.362 -1.49 -1.456V4.352C13.51 2.759 12.75 2 11.138 2h-0.376v0.964h0.273c0.964 0 1.354 0.444 1.354 1.538V6.3c0 0.984 0.492 1.497 1.497 1.6","stroke-width":"1"}})])
          )
        }
      }
    